import React from "react";
import ParticipantStatusChangeContainer from "../../../containers/ReportsContainer/ParticipantStatusChangeContainer";

const ParticipantStatusChange = (props) => {
  return <ParticipantStatusChangeContainer {...props} />;
};

export default ParticipantStatusChange;
